import { render, staticRenderFns } from "./PresenceStartStopButton.vue?vue&type=template&id=45b03bd4"
import script from "./PresenceStartStopButton.vue?vue&type=script&lang=ts"
export * from "./PresenceStartStopButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports